/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import {
  // getProductList,
  getAssociatedCompanyName,
  // getAssociatedUserDetails,
  // getCustomerDetails,
} from "../../services/return/searchProduct";
import userActions from "../../services/Login/Actions";
import i18n from "../../i18n";
import Controls from "../../components/controls";

const useStyles = makeStyles((theme) => ({
  mt20: {
    marginTop: 20,
  },
  firstCol: {
    borderRight: "1px solid white !important",
    width: "20%",
  },
  pointerEvent: {
    cursor: "pointer",
  },
  input: {
    "& .MuiOutlinedInput-root": {
      borderRadius: theme.spacing(0),
    },
    "& .MuiInputBase-inputSizeSmall": {
      padding: theme.spacing(1, 1.5),
      backgroundColor: "#fff",
    },
    "& .MuiOutlinedInput-root:hover .MuiInputBase-inputSizeSmall": {
      borderColor: "#B72755",
    },
    "& .MuiFormHelperText-marginDense": {
      margin: theme.spacing(0.5, 0.5, 0, 0.5),
    },
  },
}));

function SearchMaskInput(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [options, setOptions] = useState([]);
  const [searching, setSearching] = useState(true);
  const [tableDirty, setTableDirty] = useState(false);
  // const [results, setResults] = useState(0);
  // const [dirty, setDirty] = useState(false);
  const [enteredValue, setEnteredValue] = useState("");
  const [searchingTable, setSearchingTable] = useState(false);
  const { user } = useSelector((state) => state.authentication);
  const classes = useStyles();
  const dispatch = useDispatch();
  const { selectAccount } = props;

  const selectAccountCSRSearch = (data) => {
    const csrSearchDataformat = {
      AP_ACCOUNT_NUMBER: data?.customerAccountNumber,
      AP_CUST_ACCOUNT_ID: data?.customerAccountID,
      AP_CUSTOMER_NAME: data?.customerName,
      AP_QUALIFIER: data?.apqualifier,
      AP_COUNTRY: data?.apCountry,
    };
    const addAccount = [...user._accounts?.[0]?._element, csrSearchDataformat];
    dispatch(
      userActions.success([
        { ...user, ...{ _accounts: [{ _element: addAccount }] } },
      ])
    );
    selectAccount(csrSearchDataformat);
  };
  // search API

  function useDebounce(value, delay) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(
      () => {
        // Update debounced value after delay
        const handler = setTimeout(() => {
          setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return () => {
          clearTimeout(handler);
        };
      },
      [value, delay]
      // Only re-call effect if value or delay changes
    );
    return debouncedValue;
  }

  const debouncedSearchTerm = useDebounce(enteredValue, 1000);

  const { VITE_SEARCH_INPUT } = import.meta.env;

  const searchKeywords = async (keyword, condition) => {
    if (keyword) {
      const postData = {
        keywords: keyword,
      };
      setPage(0);
      try {
        await axios.all([
          getAssociatedCompanyName(postData)
            .then((response) => {
              const suggestedProductList = [];
              setSearching(false);
              if (response.data?.["accounts-details"]?.length > 0) {
                response.data?.["accounts-details"]?.forEach((item) => {
                  suggestedProductList.push({
                    customerAccountNumber: item?.custaccountnumber,
                    customerName: item?.custaccountname,
                    customerAccountID: item?.custaccountid,
                    apqualifier: item?.apqualifier,
                    apCountry: item?.country,
                  });
                });
                setOptions(suggestedProductList);
                // setResults(response?.data?.pagination?.results);
              } else {
                setOptions("");
              }
            })
            .catch((err) => {
              // console.error(err);
            }),
        ]);
      } catch (err) {
        // console.log(err);
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (enteredValue.length >= VITE_SEARCH_INPUT) {
        searchKeywords(debouncedSearchTerm);
      } else {
        setOptions([]);
        setSearching(false);
      }
    };
    fetchData();
  }, [debouncedSearchTerm]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // console.log('newPage', newPage);
    // const data = {
    //   keywords : 'medical'
    // }
    // getAssociatedCompanyName(data, newPage, rowsPerPage).then((res) => {
    //   const suggestedProductList = [];
    //   if (res.data?.['accounts-details']?.length > 0) {
    //     res.data?.['accounts-details']?.forEach((item) => {
    //       suggestedProductList.push({
    //         customerAccountNumber: item?.custaccountnumber,
    //         customerName: item?.custaccountname,
    //         customerAccountID: item?.custaccountid,
    //       });
    //     });
    //     setOptions(suggestedProductList);
    //     setPage(newPage);
    //     setRowsPerPage(rowsPerPage);
    //   } else {
    //     setOptions('');
    //   }
    // });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event?.target?.value);
    setPage(0);
  };

  const filterProduct = (value, event) => {
    // setDirty(true);
    setEnteredValue(value);
    setSearchingTable(true);
  };

  return (
    <div>
      <Grid item xs={12} md={12}>
        <Typography component="p" className={classes?.contctUs}>
          <b>{i18n.t("common.labels.accountSearch")}</b>
        </Typography>
        <div className="searchWithIcon">
          <Controls.Input
            name={i18n.t("common.labels.productSearch")}
            value={enteredValue}
            placeholder={i18n.t("common.labels.csrSearchPlaceholder")}
            onKeyPress={(e) => filterProduct(e?.target?.value)}
            onChange={(e) => filterProduct(e?.target?.value)}
            id="PS-INPUT-CSRAccountSearch"
          />
          <span>
            <SearchIcon id="TOP-NAV-BTN-SearchIcon" />
          </span>
        </div>
      </Grid>
      <Paper className={classes.mt20}>
        <TableContainer>
          <Table
            aria-label="Container item details table"
            className="productSearchTable"
          >
            <TableHead>
              <TableRow>
                <TableCell className={classes.firstCol}>
                  {i18n.t("common.labels.customerNumber")}
                </TableCell>
                <TableCell>{i18n.t("common.labels.customerName")}</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>

            {searching ? (
              <TableBody>
                <TableRow>
                  <TableCell
                    align="center"
                    component="td"
                    colSpan="4"
                    scope="row"
                  >
                    {i18n.t("placeOrder.productSearch.searching")}
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                {options.length === 0 ? (
                  <TableRow>
                    <TableCell
                      align="center"
                      component="td"
                      colSpan="4"
                      scope="row"
                    >
                      {i18n.t("placeOrder.productSearch.noResults")}
                    </TableCell>
                  </TableRow>
                ) : (
                  options
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    ?.map((row) => (
                      <TableRow
                        key={row.itemNbr}
                        className={classes.pointerEvent}
                      >
                        <TableCell
                          component="td"
                          scope="row"
                          data-title={i18n.t(
                            "returnHistory.table.shipmentDetailsTable.containerItems.itemNumber"
                          )}
                        >
                          {row.customerAccountNumber}
                        </TableCell>
                        <TableCell
                          data-title={i18n.t(
                            "returnHistory.table.shipmentDetailsTable.containerItems.itemUM"
                          )}
                        >
                          {row.customerName}
                        </TableCell>
                        <TableCell
                          data-title={i18n.t("placeOrder.productSearch.cart")}
                        >
                          {" "}
                          <Controls.Button
                            size="small"
                            variant="outlined"
                            text={i18n.t("warrantyLookup.warrantyFormLabelSelectAccount")}
                            onClick={() => selectAccountCSRSearch(row)}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
        {options?.length !== 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            // count={results}
            count={options.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={i18n.t("placeOrder.productSearch.rowsPerPage")}
          />
        )}
      </Paper>
    </div>
  );
}

export default SearchMaskInput;
